<script setup lang="ts">
import { computed, useAttrs, type CSSProperties, type StyleValue } from 'vue';
import type { TypographyBaseProps } from './types';

defineOptions({
  name: 'BaseText',
  inheritAttrs: false,
});

const props = withDefaults(defineProps<TypographyBaseProps>(), {
  fontFamily: 'BMWGroupTNC',
  size: 16,
  color: 'inherit',
  weight: 400,
  onClick: undefined,
});

const attrs = useAttrs();

const forwardedAttrs = computed(() => {
  const { style, ...rest } = attrs;
  return rest;
});

const resolvedFontFamily = computed(() => {
  if (props.fontFamily === 'BMWTypeNext') {
    return 'BMWTypeNext, sans-serif';
  }
  return 'BMWGroupTNC, sans-serif';
});

const resolvedFontSize = computed(() => {
  if (typeof props.size === 'number') {
    return `${props.size / 100}rem`;
  }
  return props.size;
});

const baseStyle = computed<CSSProperties>(() => ({
  display: 'inline-block',
  fontFamily: resolvedFontFamily.value,
  fontSize: resolvedFontSize.value,
  color: props.color,
  fontWeight: props.weight,
}));

const mergedStyle = computed<StyleValue>(() => [baseStyle.value, attrs.style as StyleValue]);

const handleClick = (event: MouseEvent) => {
  props.onClick?.(event);
};

const noop = () => {};
</script>

<template>
  <div v-bind="forwardedAttrs" :style="mergedStyle" @click="handleClick" @keypress="noop">
    <slot />
  </div>
</template>
